import { h } from 'preact'

import cxs from 'cxs'

// const primaryColor = '#343334'
const primaryColor = '#010033'

const className = cxs({
  border: `2px solid ${primaryColor}`,
  backgroundColor: primaryColor,
  fontSize: '1em',
  borderRadius: '0',
  cursor: 'pointer',
  color: 'white',
  padding: '0 18px',
  height: '41px',
  ':active': {
    border: '2px solid #6c757d',
    backgroundColor: '#6c757d',
  },
  ':disabled': {
    border: '2px solid #6c757d',
    backgroundColor: '#6c757d',
  },
})

const outlineClass = cxs({
  backgroundColor: 'transparent',
  color: primaryColor,
  ':hover': {
    backgroundColor: primaryColor,
    color: '#fff',
  },
})

class Button {
  render({ type = 'button', children, outline = false, ...rest }) {
    return (
      <button type={type} {...rest} class={`${className} ${rest.class} ${outline && outlineClass}`}>
        {children}
      </button>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./components/Button.js